import React from "react";

/**
 * Card/tile primitive used across dashboard-style layouts. Matches the
 * `ContentTile` shape from the legacy app but as plain Tailwind.
 */
export function Tile({
  title,
  className = "",
  children,
}: {
  title?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <section
      className={`rounded-lg border border-border/60 bg-surface shadow-card p-md flex flex-col ${className}`}
    >
      {title !== undefined && (
        <h3 className="text-sm font-medium text-text mb-sm">{title}</h3>
      )}
      <div className="flex-1 flex flex-col min-h-0">{children}</div>
    </section>
  );
}

/** 12-column grid container matching the legacy layout idiom. */
export function TileGrid({ children, className = "" }: { children: React.ReactNode; className?: string }) {
  return <div className={`grid grid-cols-12 gap-md ${className}`}>{children}</div>;
}

/** Big metric display — used for "Tests Executed", "Reagent Efficiency", etc. */
export function BigMetric({ value, label }: { value: React.ReactNode; label?: React.ReactNode }) {
  return (
    <div className="flex-1 flex flex-col items-center justify-center py-md">
      <div className="text-4xl font-semibold text-text">{value}</div>
      {label && <div className="text-xs text-textLight mt-xs">{label}</div>}
    </div>
  );
}

/**
 * Standin banner — disabled. Pages still render mock data where backend is
 * missing, but the yellow banners are suppressed. Restore by returning the
 * commented JSX below when the docs/backend-holes.md items are addressed.
 */
export function PreviewBanner(_: { children: React.ReactNode }) {
  return null;
  // return (
  //   <div className="rounded-md border border-warning-text/30 bg-warning-bg text-warning-text px-md py-sm text-xs">
  //     {children}
  //   </div>
  // );
}
